import type { Block, BlockType } from "@/types";

/** Human label + group for each block type, for the Add menu and row labels. */
export const BLOCK_META: Record<BlockType, { label: string; group: "Core" | "Editorial" }> = {
  cover: { label: "Cover", group: "Core" },
  rich_text: { label: "Rich text", group: "Core" },
  image: { label: "Image", group: "Core" },
  pricing: { label: "Pricing", group: "Core" },
  terms: { label: "Terms", group: "Core" },
  accept: { label: "Accept", group: "Core" },
  author: { label: "Author", group: "Editorial" },
  quote: { label: "Testimonial", group: "Editorial" },
  split: { label: "Split", group: "Editorial" },
  feature_grid: { label: "Feature grid", group: "Editorial" },
  embed: { label: "Embed", group: "Editorial" },
};

export const CORE_TYPES: BlockType[] = ["cover", "rich_text", "image", "pricing", "terms", "accept"];
export const EDITORIAL_TYPES: BlockType[] = ["author", "quote", "split", "feature_grid", "embed"];

function newId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) return crypto.randomUUID();
  return "b-" + Math.random().toString(36).slice(2, 10);
}

/** Create a new block of `type` with sensible defaults (§5). */
export function createBlock(type: BlockType): Block {
  const id = newId();
  switch (type) {
    case "cover":
      return { id, type, props: { title: "Your project", subtitle: "" } };
    case "rich_text":
      return { id, type, props: { heading: "", body_md: "" } };
    case "image":
      return { id, type, props: { asset_url: "", alt: "", layout: "full" } };
    case "pricing":
      return { id, type, props: { heading: "Fees" } };
    case "terms":
      return { id, type, props: { heading: "Notes & terms", body_md: "" } };
    case "accept":
      return { id, type, props: { require_name: true, ask_decline_reason: true } };
    case "author":
      return { id, type, props: { name: "", role: "", note: "" } };
    case "quote":
      return { id, type, props: { text: "", attribution: "" } };
    case "split":
      return { id, type, props: { heading: "", body_md: "", image_side: "left" } };
    case "feature_grid":
      return { id, type, props: { heading: "What's included", items: [{ title: "", body: "" }] } };
    case "embed":
      return { id, type, props: { url: "", caption: "" } };
  }
}
